<template>

  <div class="service__details">
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="4"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ reservationDetail.stringID }} - {{ reservationDetail.productType }}
            </h1>
            <p class="log_info"> Created by {{ getCreatedBy() }} on {{ dateFormatWithTime(reservationDetail.createdAt) }}
              <br>Last updated on {{ dateFormatWithTime(reservationDetail.updatedAt) }}
            </p>
          </b-col>
        </b-row>
      </b-col>

      <!-- Content Right -->
      <b-col
        class="content-header-right text-md-right mb-1"
        md="8"
        cols="12"
      >
        <div
          v-if="(canViewThisAction('release', 'LotReservation') || canViewThisAction('release-staff-hold', 'LotReservation')) && (reservationDetail.status === 'Reserved' || reservationDetail.status === 'Staff Hold')"
          class="user_block low-width"
        >
          <b-dropdown
            variant="flat-primary"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreHorizontalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="reservationDetail.status == 'Staff Hold' && !canViewThisAction('release-staff-hold', 'LotReservation')"
              class="btn-primary-dropdown"
              @click="showNotAllowedWarning"
            >
              <feather-icon icon="WindIcon" />
              <span class="align-middle ml-50">Release Lot</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-else
              class="btn-primary-dropdown"
              @click="showReleaseWarning"
            >
              <feather-icon icon="WindIcon" />
              <span class="align-middle ml-50">Release Lot</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="user_block pr_stage_type">
          <div class="user_avatar" />
          <div class="user_info">
            <h6>Reservation Status</h6>
            <h5 :class="`text-${resolveStatusVariant(reservationDetail.status)}`">
              {{ reservationDetail.status }}
            </h5>
          </div>
        </div>
        <div class="user_block">
          <div class="user_avatar">
            <img :src="agentData ? (agentData.image ? agentData.image : defaultImage) : defaultImage">
          </div>
          <div class="user_info">
            <h6>Service Agent</h6>
            <h5>
              <b-button
                v-if="agentData && agentData.agent && canViewThisAction('show', 'Agent')"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="link"
                class="fs-15 weight-500 p-0 text-underline"
                :to="{ name: 'agency-agents-show', params: { id: agentData.agent._id } }"
              >
                {{ agentData.name || '-' }}
              </b-button>
              <b-button
                v-else-if="agentData && agentData.name && canViewThisAction('show', 'Agent')"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="link"
                class="fs-15 weight-500 p-0 text-underline"
                :to="{ name: 'agency-agents-show', params: { id: agentData._id } }"
              >
                {{ agentData.name || '-' }}
              </b-button>
              <span v-else>{{ agentData.name || '-' }}</span>
            </h5>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- Table Container Card -->

    <b-card
      class="mb-3 p-2 calllog-details serviceForm_details extra_off_bg"
    >
      <b-row
        class="content-header"
      >

        <!-- Content Left -->
        <b-col
          class="content-header-left mb-1"
          style="margin-bottom: 20px !important;"
          md="6"
        >
          <b-card
            class="has-padding h-100"
            style="margin: 0 !important;"
          >
            <b-card-title>
              Reservation Details
            </b-card-title>
            <b-card-body>
              <b-table-simple
                borderless
                responsive
                class="particulars_of_deceased d-none d-md-block"
              >
                <b-tbody>
                  <b-tr>
                    <b-th width="230px">
                      Reserve For
                    </b-th>
                    <b-td>{{ reservationDetail.reservationFor ? reservationDetail.reservationFor : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Reserve Period
                    </b-th>
                    <b-td>{{ reservationDetail.reservationStartDate ? dateFormatWithTime(reservationDetail.reservationStartDate) : '-' }} - {{ reservationDetail.reservationEndDate ? dateFormatWithTime(reservationDetail.reservationEndDate) : 'Infinite' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Time Left
                    </b-th>
                    <b-td>
                      <span class="text-danger-light">{{ getHoursMinsSeconds(reservationDetail.reservationEndDate) }}</span>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>

              <hr>

              <div>
                <h5 class="dark-font-weight-bold">
                  Remarks
                </h5>
                <b-row>
                  <b-col
                    class="content-header-left"
                    cols="9"
                    md="9"
                    sm="9"
                    lg="10"
                  >
                    <p>{{ reservationDetail.remarks ? reservationDetail.remarks : '-' }}</p>
                  </b-col>
                  <!-- <b-col
                    class="content-header-left text-right"
                    cols="3"
                    md="3"
                    sm="3"
                    lg="2"
                  >
                    <b-button
                      v-if="canViewThisAction('update', 'File')"
                      v-b-tooltip.hover.top="'Edit Remarks'"
                      variant="flat-primary"
                      class="edit_remark_button"
                      @click="editRemarks"
                    >
                      <feather-icon
                        class="cursor-pointer"
                        icon="EditIcon"
                        size="16"
                      />
                    </b-button>
                  </b-col> -->
                </b-row>
              </div>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col
          class="content-header-left mb-1"
          style="margin-bottom: 20px !important;"
          md="6"
        >
          <b-card
            class="has-padding h-100"
            style="margin: 0 !important;"
          >
            <b-card-title>
              Lot Details
            </b-card-title>
            <b-card-body>
              <b-table-simple
                borderless
                responsive
                class="particulars_of_deceased d-none d-md-block"
              >
                <b-tbody>
                  <b-tr>
                    <b-th width="230px">
                      Zone No.
                    </b-th>
                    <b-td>{{ reservationDetail.lot ? (reservationDetail.lot.zoneNo || '-') : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Lot No.
                    </b-th>
                    <b-td>{{ reservationDetail.lot ? (reservationDetail.lot.lotNo || '-') : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Lot Type
                    </b-th>
                    <b-td>{{ reservationDetail.lot ? (reservationDetail.lot.lotType || '-') : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Bury Capacity
                    </b-th>
                    <b-td>{{ reservationDetail.lot ? (reservationDetail.lot.buryCapacity || '-') : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Area Length
                    </b-th>
                    <b-td>{{ reservationDetail.lot ? (reservationDetail.lot.size || '-') : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Direction
                    </b-th>
                    <b-td>{{ reservationDetail.lot ? (reservationDetail.lot.direction || '-') : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Side
                    </b-th>
                    <b-td>{{ reservationDetail.lot ? (reservationDetail.lot.side || '-') : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Level No.
                    </b-th>
                    <b-td>{{ reservationDetail.lot ? (reservationDetail.lot.levelNo || '-') : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Section No.
                    </b-th>
                    <b-td>{{ reservationDetail.lot ? (reservationDetail.lot.section || '-') : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Land Category
                    </b-th>
                    <b-td>{{ reservationDetail.lot ? (reservationDetail.lot.landCategory || '-') : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Interment Date
                    </b-th>
                    <b-td>
                      {{ reservationDetail.lot ? (reservationDetail.lot.intermentDate ? dateFormat(reservationDetail.lot.intermentDate) : '-') : '-' }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>

              <hr>

              <div>
                <h5 class="dark-font-weight-bold">
                  Remarks
                </h5>
                <b-row>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <p>{{ reservationDetail.lot ? (reservationDetail.lot.remarks || '-') : '-' }}</p>
                  </b-col>
                </b-row>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col
          class="content-header-left h-100"
          md="12"
        >
          <b-card
            class="has-padding"
          >
            <b-card-title>
              Agent Details
            </b-card-title>
            <b-card-body v-if="agentData.name">
              <b-card-text>
                <b-media
                  left-align
                  vertical-align="center"
                  class="p4b__onboarding-form-media"
                >
                  <template #aside>
                    <b-avatar
                      size="150px"
                      :src="agentData.image"
                      :text="resolveAcronymName(agentData.name)"
                    />
                  </template>
                  <b-table-simple
                    borderless
                    responsive
                    class="mb-0 p4b__agent-details-cm-table"
                  >
                    <b-tbody>
                      <b-tr>
                        <b-th
                          width="260px"
                          class="weight-500"
                          style="padding-left: 0 !important;"
                        >
                          Name
                        </b-th>
                        <b-td style="padding-left: 0 !important;">
                          {{ agentData.name || '-' }}
                        </b-td>
                        <b-th
                          width="260px"
                          class="weight-500"
                          style="padding-left: 0 !important;"
                        >
                          Mobile Number
                        </b-th>
                        <b-td style="padding-left: 0 !important;">
                          <span v-if="agentData.agent">
                            {{ agentData.contact || '-' }}
                          </span>
                          <span v-else>
                            {{ agentData.personalContact || '-' }}
                          </span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th
                          width="260px"
                          class="weight-500"
                          style="padding-left: 0 !important;"
                        >
                          Agent Code
                        </b-th>
                        <b-td style="padding-left: 0 !important;">
                          {{ agentData.code || '-' }}
                        </b-td>
                        <b-th
                          width="260px"
                          class="weight-500"
                          style="padding-left: 0 !important;"
                        >
                          Status
                        </b-th>
                        <b-td
                          style="padding-left: 0 !important;"
                          class="text-capitalize"
                        >
                          <span
                            v-if="agentData.status == 'active'"
                            class="text-success"
                          >{{ agentData.status || '-' }}</span>
                          <span>{{ agentData.status || '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th
                          width="260px"
                          class="weight-500"
                          style="padding-left: 0 !important;"
                        >
                          Card Display Name
                        </b-th>
                        <b-td style="padding-left: 0 !important;">
                          {{ agentData.cardDisplayName || '-' }}
                        </b-td>
                        <b-th
                          width="260px"
                          class="weight-500"
                          style="padding-left: 0 !important;"
                        >
                          Remarks
                        </b-th>
                        <b-td style="padding-left: 0 !important;">
                          {{ agentData.remarks || '-' }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th
                          width="260px"
                          class="weight-500"
                          style="padding-left: 0 !important;"
                        >
                          Agency
                        </b-th>
                        <b-td style="padding-left: 0 !important;">
                          <span v-if="agentData.agent">
                            {{ agentData.agent.agencyName ? agentData.agent.agencyName : '-' }} ({{ agentData.agent.agencyCode ? agentData.agent.agencyCode : '-' }}) - {{ agentData.agent.agencyCountry ? agentData.agent.agencyCountry : '-' }}
                          </span>
                          <span v-else>
                            {{ agentData.agencyName ? agentData.agencyName : '-' }} ({{ agentData.agencyCode ? agentData.agencyCode : '-' }}) - {{ agentData.agencyCountry ? agentData.agencyCountry : '-' }}
                          </span>
                        </b-td>
                        <b-td />
                        <b-td />
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-media>
              </b-card-text>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <b-card
      class="mb-3 mt-3 p-2"
    >
      <b-row
        class="content-header"
      >
        <!-- Content Left -->
        <b-col
          class="content-header-left mb-2 p-2"
          cols="12"
          md=""
        >
          <h4>
            <feather-icon
              icon="ListIcon"
              class="mr-50"
              size="16"
            />
            <span class="align-middle">Activity Logs</span>
          </h4>
        </b-col>
      </b-row>
      <app-timeline>
        <!-- FINANCIAL REPORT -->
        <app-timeline-item
          v-for="(opt, key) in activityLogs"
          :key="key"
          :variant="getVariant(key)"
        >

          <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
            <h6>{{ opt.title }}</h6>
            <small class="text-muted">{{ dateFormatWithTime(opt.time) }}</small>
          </div>
        </app-timeline-item>
      </app-timeline>
    </b-card>
    <!-- ./ return inventory item preview modal -->
  </div>
</template>

<script>
import {
  BCard, BCardBody, BCardText, BCardTitle, BRow, BCol, VBToggle, VBTooltip, BButton, BTableSimple, BTbody, BTr, BTh, BTd, BMedia, BAvatar,
  BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import store from '@/store/index'
import { required } from '@validations'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import Ripple from 'vue-ripple-directive'

import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const { canViewThisAction } = useAclUtils()
export default {
  components: {
    BCard,
    BCardTitle,
    BCardText,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BTd,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,

    AppTimeline,
    AppTimelineItem,
  },
  directives: { 'b-toggle': VBToggle, 'b-tooltip': VBTooltip, Ripple },
  data() {
    return {
      canViewThisAction,
      user: store.state.auth.userData,
      required,
      // eslint-disable-next-line global-require
      defaultImage: require('@/assets/images/placeholder/placeholder_image.png'),
      reservationDetail: {},
      activityLogs: [],
      agentData: {},
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.$http.get(`reservation/agent/reservations/${this.$route.params.id}/show`)
        .then(response => {
          this.reservationDetail = response.data.reservationDetail || {}
          // eslint-disable-next-line no-nested-ternary
          this.agentData = response.data.reservationDetail.agent ? response.data.reservationDetail.agent : (response.data.reservationDetail.mainAgent ? response.data.reservationDetail.mainAgent : {})
          this.activityLogs = response.data.reservationDetail.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time)) || []
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    getVariant(key) {
      if (key % 4 === 0) return 'info'
      if (key % 4 === 1) return 'warning'
      if (key % 4 === 2) return 'danger'
      if (key % 4 === 3) return 'purple'
      return 'primary'
    },
    getCreatedBy() {
      if (this.reservationDetail.createdByNvs) {
        return this.reservationDetail.createdByNvs.name
      }
      if (this.reservationDetail.mainAgent) {
        return this.reservationDetail.mainAgent.name
      }
      if (this.reservationDetail.agent) {
        return this.reservationDetail.agent.name
      }

      return '-'
    },
    resolveStatusVariant(status) {
      if (status === 'Reserved') return 'warning'
      return 'primary'
    },
    getHoursMinsSeconds(endTime) {
      if (!endTime) {
        return 'Infinite'
      }
      const start = new Date()
      const end = new Date(endTime)
      const diff = end.getTime() - start.getTime()

      if (diff < 0) {
        return '00:00:00'
      }

      const hours = Math.floor(diff / 1000 / 60 / 60)
      const minutes = Math.floor(diff / 1000 / 60) % 60
      const seconds = Math.floor(diff / 1000) % 60 // Include seconds for better accuracy

      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    },
    resolveAcronymName(name) {
      return name.split(' ').map(item => item.charAt(0)).join('').toUpperCase()
    },
    showReleaseWarning() {
      this.$swal({
        title: 'Are you sure you want to<br>release this lot?',
        html: `<p class='mt-1' />Releasing the lot before the scheduled<br>release date means that the customer <span class="text-bold-black">${this.reservationDetail.reservationFor}</span> will no longer have a reservation,<br>and the lot will become available to others.<br>Are you sure you want to proceed?`,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/wind.png'),
        input: 'textarea',
        inputPlaceholder: 'Add Remarks',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: 'Yes, release this lot',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
          input: 'reject-note-ta',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.isConfirmed) {
            this.$http.post(`reservation/agent/reservations/${this.$route.params.id}/release`, {
              remarks: result.value || '',
            })
              .then(response => {
                this.reservationDetail.status = response.data.reservationDetail.status || 'Released'
                this.reservationDetail.remarks = response.data.reservationDetail.remarks || ''
                this.reservationDetail.reservationEndDate = response.data.reservationDetail.reservationEndDate || ''
                this.activityLogs = response.data.reservationDetail.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time)) || []
                this.$swal({
                  title: 'Lot Released!',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/success.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    showNotAllowedWarning() {
      this.$swal({
        title: 'You do not have the necessary permissions to release a Staff Hold reservation.',
        html: 'Please check with your system administrator if you need further details.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        reverseButtons: true,
        showCancelButton: false,
        confirmButtonText: 'Ok, got it',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
  },
}
</script>
  <style>
  .card.mb-3.p-2.without__bg.extra__bg::before {
      position: absolute;
      top: -24px;
      bottom: -24px;
      right: -24px;
      content: "";
  }
  .verify-request-section{
       background: #F5F8FB;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
  }
  .verify-request-wrapper {
      padding: 2rem;
  }
  .request-img-section{
    display: flex;
    align-items: end;
    justify-content: end;
  }
  @media (max-width: 767px) {
    .card.mb-3.p-2.without__bg.extra__bg::before {
      right: -16px;
  }
    .verify-request-wrapper {
      padding: 1rem;
  }
    .request-img-section{
    align-items: center;
    justify-content: center;
  }
  }
    /* requested inventory item modal */
    .modal .form-control {
      margin: 0;
  }
    .stock-items-modal-header{
      margin: 20px auto 0px auto;
      text-align: center;
    }
      .img-preview-block{
        box-sizing: border-box;
        width: 38px;
        height: 38px;
        border: 1px solid #D2DCEA;
        border-radius: 5px;
    }
    .full-return-checkbox{
    display: flex;
    align-items: end;
    justify-content: end;
  }
  .text-underline {
    text-decoration: underline;
  }

  .extra_off_bg {
    border-radius: 0px 0px 6px 6px;
    background: #F8F8F8;
  }

  .user_block.low-width {
    max-width: 66px;
    min-width: 66px;
    width: 66px;
    overflow: visible;
  }
  .user_block.low-width ul {
      left: auto !important;
      right: 0 !important;
  }

  .user_block.low-width button {
      width: 66px !important;
  }
  .text-danger-light {
    color: #EA5455;
  }

  .dark-font-weight-bold {
    font-weight: 500 !important;
    color: #000;
  }
  .btn-primary-dropdown a:hover {
    background-color: #104D9D !important;
    color: #fff !important;
  }
    /* ./ requested inventory item modal */
  </style>
